import React from 'react';
import { useSelector } from 'react-redux';

import { withTranslations } from '@common/hoc';
import { referralEligibilityDataSelector } from '../selectors/user';

const withMenteeReferralTranslations = (path, feature = '') => (
  (BaseComponent) => {
    const DerivedComponent = withTranslations(path, feature)(BaseComponent);
    return function FinalComponent(props) {
      const { locale } = useSelector(referralEligibilityDataSelector);
      return (
        <DerivedComponent
          locale={locale}
          {...props}
        />
      );
    };
  }
);
export default withMenteeReferralTranslations;
